<div class="flex justify-content-center align-items-center h-screen">
   @if (setPage() === 1) {
      <div class="w-full" style="max-width: 450px;">
         <form [formGroup]="formData" (ngSubmit)="sendResetPassword()">
            <p-card styleClass="h-auto p-3">
               <div class="flex flex-column gap-4">
                  <h5 class="flex flex-column align-items-center justify-content-center gap-2">
                     <img class="mb-1" src="images/logo.png" width="70" alt="ep-logo">
                     <span class="text-xl font-bold">Forgot Password</span>
                     <p class="text-center w-10 text-base">Please enter your phone number to request a password reset.</p>
                  </h5>
                  <p-messages 
                     [(value)]="snackBarErrorMessage" 
                     [enableService]="false" 
                     [closable]="false" 
                     styleClass="-mt-5"
                  />
                  <div class="flex flex-column gap-1">
                     <label for="countryCode" class="ml-1">Select country code</label>
                     <p-dropdown 
                        formControlName="countryCode" 
                        [options]="countryCodes"
                        optionLabel="name"
                        styleClass="w-full"
                        (onChange)="isPhoneNumberValid.set(true)"
                     >
                        <ng-template pTemplate="selectedItem">
                           @if (countryCode) {
                              <div class="flex align-items-center gap-2">
                                 <img [src]="'assets/flags/64x64/'+countryCode.Alpha2+'.png' | lowercase"
                                    style="width: 18px" 
                                 />
                                 <div>{{ countryCode.name }}</div>
                              </div>
                           }
                        </ng-template>
                        <ng-template let-countryCode pTemplate="item">
                              <div class="flex align-items-center gap-2">
                                 <img 
                                    [src]="'assets/flags/64x64/'+countryCode.Alpha2+'.png' | lowercase"
                                    style="width: 18px" />
                                 <div>{{ countryCode.name }}</div>
                              </div>
                        </ng-template>
                     </p-dropdown>
                  </div>
         
                  <div class="flex flex-column gap-1">
                     <label for="phoneNumber" class="ml-1">Enter phone number</label>
                     <div>
                        <p-inputGroup>
                           <p-inputGroupAddon>
                              {{ countryCode.code }}
                           </p-inputGroupAddon>
                           <input 
                              pInputText
                              pKeyFilter="num"
                              formControlName="phoneNumber"
                              class="w-full"
                              (keydown)="inputNumberOnly($event)"
                           />
                     </p-inputGroup>
                  </div>
                     @if ((phoneNumber.dirty || phoneNumber.touched) && phoneNumber.errors?.['required']) {
                        <small class="text-red-500">Phone number is required!</small>
                     }
                     @if (!isPhoneNumberValid() && phoneNumber.touched) {
                        <small class="text-red-500">Phone number is invalid!</small>
                     }
                  </div>

                  <re-captcha 
                     class="flex justify-content-center" 
                     [siteKey]="sitekey"
                     [theme]="theme"
                     (resolved)="resolved($event)" 
                  />

                  <label class="ml-1 mt-3">Send reset password via</label>
                  <div class="flex justify-content-between gap-3 -mt-2 mb-3">
                     <div *ngFor="let option of options" class="flex w-full gap-2">
                        <label 
                           class="card-radio" 
                           [class.selected]="formData.get('email')?.value === option.sendViaSMS"
                        >
                           <input
                              type="radio"
                              formControlName="email"
                              [value]="option.sendViaSMS"
                              (ngModelChange)="radioButtonChange($event)"
                           />
                           <div class="flex gap-2">
                              <i [class]="option.icon" style="font-size: 1.2rem"></i>
                              <span class="txt-padding">{{ option.label }}</span>
                           </div>
                         </label>
                     </div>
                 </div>

                  <p-button 
                     type="submit" 
                     label="Send Reset Password" 
                     styleClass="w-full" 
                     [icon]="loading() ? 'pi pi-spin pi-spinner' : ''" 
                     [disabled]="loading() || !captcha.value || !phoneNumber.value"
                     iconPos="right"
                  />
                  <div class="mt-3 w-full">
                     <a routerLink="/login" class="text-primary gap-2 flex justify-content-center align-items-center">
                        <i class="pi pi-arrow-left -mt-1"></i>
                        Back to login
                    </a>
                  </div>
               </div>
            </p-card>
         </form>
      </div>
   }
   @if (setPage() === 2) {
      <div class="w-full" style="max-width: 450px;">
         <p-card styleClass="h-auto p-3">
            <div class="flex flex-column gap-4">
               <h5 class="flex flex-column align-items-center justify-content-center gap-2">
                  <img class="mb-1" src="images/logo.png" width="70" alt="ep-logo">
                  <span class="text-xl font-bold">Password Reset</span>
                  <p class="text-center w-10 text-base">
                     We send the code to 
                     <span>{{ sendViaSMS ? mobileNumber : 'your email'}}</span>
                  </p>
               </h5>
               <p-messages 
                  [(value)]="snackBarErrorMessage" 
                  [enableService]="false" 
                  [closable]="false" 
                  styleClass="-mt-5"
               />
               <div class="flex justify-content-center">
                  <p-inputOtp [(ngModel)]="otpValue" [integerOnly]="true" (onChange)="otpOnChange($event)">
                     <ng-template pTemplate="input" let-token let-events="events">
                        <input 
                           pInputText 
                           class="custom-otp-input" 
                           (input)="events.input($event)" 
                           (keydown)="events.keydown($event)" 
                           type="text" 
                           [attr.value]="token" 
                           [maxLength]="1" 
                        />
                     </ng-template>
                  </p-inputOtp>
               </div>
               <p-button 
                  label="Verify" 
                  (onClick)="verifyOTP()" 
                  [icon]="loading() ? 'pi pi-spin pi-spinner' : ''" 
                  [disabled]="loading()"
                  styleClass="w-full mt-3" 
               />
            </div>
         </p-card>
      </div>
   }

   @if (setPage() === 3) {
      <div class="w-full" style="max-width: 450px;">
         <form [formGroup]="passwordForm" (ngSubmit)="submitNewPassword()">
            <p-card styleClass="h-auto p-3">
               <div class="flex flex-column gap-4">
                  <h5 class="flex flex-column align-items-center justify-content-center gap-2">
                     <img class="mb-1" src="images/logo.png" width="70" alt="ep-logo">
                     <span class="text-xl font-bold">Set New Password</span>
                     <p class="text-center w-10 text-base">Password must be at least 8-characters long.</p>
                  </h5>
                  <p-messages 
                     [(value)]="snackBarErrorMessage" 
                     [enableService]="false" 
                     [closable]="false" 
                     styleClass="-mt-5"
                  />
                  <div class="flex flex-column gap-1">
                     <label class="ml-1">Enter New Password<sup class="text-red-500">*</sup></label>
                     <p-password 
                        styleClass="w-full" 
                        [inputStyle]="{'width':'100%'}" 
                        [toggleMask]="true" 
                        formControlName="password" 
                        [feedback]="false" 
                     />
                     @if ((password.dirty || password.touched) && password.errors?.['required']) {
                        <small class="ml-1 text-red-500">Password is required!</small>
                     }
                     @if (password.errors?.['minlength'] && (password.dirty || password.touched)) {
                        <small class="ml-1 text-red-500">Password must be at least 8 characters long.</small>
                     }
                  </div>
                  <div class="flex flex-column gap-1">
                     <label class="ml-1">Confirm New Password<sup class="text-red-500">*</sup></label>
                     <p-password 
                        styleClass="w-full" 
                        [inputStyle]="{'width':'100%'}" 
                        [toggleMask]="true" 
                        formControlName="confirmPassword" 
                        [feedback]="false" 
                     />
                     @if ((confirmPassword.dirty || confirmPassword.touched) && confirmPassword.errors?.['required']) {
                        <small class="ml-1 text-red-500">Confirm password is required!</small>
                     }
                     @if (passwordForm.errors?.['passwordMismatch'] && confirmPassword.touched) {
                        <small class="ml-1 text-red-500">Passwords do not match.</small>
                     }
                  </div>
                  
                  <p-button 
                     type="submit" 
                     label="Reset Password"
                     styleClass="w-full mt-3"
                     [icon]="loading() ? 'pi pi-spin pi-spinner' : ''" 
                     [disabled]="loading()"
                  />
               </div>
            </p-card>
         </form>
      </div>
   }
   @if (setPage() === 4) {
      <div class="w-full" style="max-width: 450px;">
         <p-card styleClass="h-auto p-3">
            <div class="flex flex-column gap-4">
               <h5 class="flex flex-column align-items-center justify-content-center gap-2">
                  <img class="mb-1" src="images/logo.png" width="70" alt="ep-logo">
               </h5>

               <div class="flex flex-column align-items-center justify-content-center gap-2">
                  <span class="text-2xl font-bold">All Done!</span>
                  <p class="text-center w-10 text-base">
                     Your password has been reset. Login your new credentials.
                  </p>
               </div>
              
               <div class="mt-3 w-full flex justify-content-center align-items-center">
                  <p-button (click)="redirectLogin()">
                     Login now
                  </p-button>
               </div>
            </div>
         </p-card>
      </div>
   }
</div>

